import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const CalendarContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    @media print {
        ${BaseStyle.Mixins.gaps.small}
        position: fixed;
        scale: 48%;
        margin-top: -300px;
        margin-left: -500px;
        // Currently vendor prefixing is disabled by default, but will keep both added just in case
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;

        @page {
            size: landscape;
        }

        div,
        .rt-td {
            margin: 0;
        }
    }
`;

export const CalendarTable = styled.div`
    margin-bottom: 20px;

    .rt-tr {
        ${BaseStyle.Mixins.gaps.tiny}
        margin-bottom: ${BaseStyle.GAP_SIZES.tiny}px;

        ${BaseStyle.Mixins.screenSizes.medium} {
            margin-bottom: ${BaseStyle.GAP_SIZES.small}px;
            ${BaseStyle.Mixins.gaps.small}
        }
    }

    .rt-th {
        overflow: visible;
    }

    @media print {
        min-width: fit-content;
        width: 200vw;

        .rt-tr {
            margin-bottom: ${BaseStyle.GAP_SIZES.small}px;
        }

        .rt-td {
            margin-right: ${BaseStyle.GAP_SIZES.small}px;
        }
    }
`;

export const WeekDayContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']}
    display: flex;
    flex: 1;
    flex-direction: column;
    text-align: center;
    color: ${({ theme }) => theme.Text.secondary};
    text-transform: uppercase;
    margin-bottom: 8px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['18b']}
        margin-bottom: 8px;
        color: ${({ theme }) => theme.Text.primary};
        text-transform: capitalize;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['22b']}
    }

    @media print {
        ${BaseStyle.Mixins.fontStyles.ui['22b']};
        color: ${({ theme }) => theme.Text.primary};
        text-transform: capitalize;
    }
`;
